<template>

<transition name="page-overlay">
    <div id="playlist-popup" class="page-overlay dark">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 header text-center">
                    <div class="close-button button button-white button-center" @click="close">
                        <i class="iconify icon:entypo:chevron-thin-down"></i>
                    </div>

                    <div class="cover" :style="songPicture"></div>
                    <p class="name">{{ song.name }}</p>
                    <p class="artist">{{ song.artist }}</p>
                </div>

                <div class="col-xs-12 content">
                    <!-- <h3 v-show="playlistArray.length">Add to playlists.</h3> -->

                    <ul class="list">
                        <li class="button button-white playlist" v-for="(p,i) in playlistArray" v-show="playlistArray.length" :data-id="p.id" :class="{ 'no-border' : i == playlistArray.length - 1 }">
                            <input type="checkbox" class="icheckbox" v-model="checked[p.id]" :id="'aaa-' + p.id">
                            <label class="name" :for="'aaa-' + p.id">{{ p.name }}</label>
                            <span class="count">{{ p.songs_count }}</span>
                        </li>
                        <li class="button button-white empty no-border" v-show="!playlistArray.length">
                            <span class="iconify" data-icon="dashicons:playlist-audio" data-inline="false" data-height="36"></span><br><br>
                            No playlist available<br>
                            Click to add new playlist<br>
                            <span class="iconify" data-icon="ei:chevron-down" data-inline="false" data-height="32"></span>
                        </li>
                    </ul>
                </div>

                <div class="col-xs-12 text-center footer">
                    <input v-model="fieldName" ref="fieldName" placeholder="Create new playlist ..." v-show="true" @keyup.enter="submitForm()">
                    <div class="btn btn-round btn-block btn-new-playlist button" @click="submitForm()">
                        <span v-show="!loading"><i class="iconify icon:ic:outline-add-circle"></i>CREATE NEW PLAYLIST</span>
                        <loader v-show="loading" color="ripple" size="100px"></loader>&nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
</transition>
 
</template>

<script>
export default {
    props: ['song'],

    components: {
        'loader': require('@/components/Loader.vue').default,
    }, 

    data() {
        return {
            playlistArray: [],
            checked: {},
            fieldName: "",
            loading: false
        }
    },

    mounted() {
        this.playlistArray = App.playlists.sort(function(a,b){return b.songs_count - a.songs_count;});

        this.$http.get(this.getSongPlaylistsEndpoint).then((success) => {
            var availableIn = success.data;

            $.each(this.playlistArray, (i, p) => {
                if ( $.inArray(p.id, availableIn) > -1 ){
                    this.checked[p.id] = true;
                    $('#playlist-popup li[data-id="'+ p.id +'"] .icheckbox').iCheck('check');
                }else{
                    this.checked[p.id] = false;
                    $('#playlist-popup li[data-id="'+ p.id +'"] .icheckbox').iCheck('uncheck');
                }
            });

            $('#playlist-popup .icheckbox').iCheck('enable');
        }); 

        var that = this;
        $('#playlist-popup').on('click', '.icheckbox', function(event){
            var chkbox = $(this);
            var id = chkbox.closest('li').attr('data-id');
            var checked = chkbox.is(":checked");
            chkbox.prop("disabled", true);

            // if we check
            if ( checked ){
                that.$http.post(`${that.getPlaylistsEndpoint}/${id}/song/${that.song.id}`).then((success) => {
                    chkbox.prop("disabled", false);

                    if (App.allowGtag) gtag('event', 'add_to_playlist', {
                        'event_category' : 'general',
                        'event_label' : `Add ${ that.song.uploader_id == App.user.id ? 'own' : 'other user' } song to personal list`
                    });

                    $.each(that.playlistArray, function(i, p){
                        if (p.id == id) p.songs_count++;
                    });
                }, (error) => {
                    chkbox.prop("disabled", true);
                    chkbox.prop("checked", false);
                });
            }else{
                that.$http.delete(`${that.getPlaylistsEndpoint}/${id}/song/${that.song.id}`).then((success) => {
                    chkbox.prop("disabled", false);

                    $.each(that.playlistArray, (i, p) => { 
                        if (p.id == id) p.songs_count--;
                    });
                 }, (error) => {
                    chkbox.prop("disabled", true);
                    chkbox.prop("checked", true);
                });
            }
        });

        var $mp = $("#playlist-popup");
        var that = this;

        var y0 = 0, y1 = 0, y2 = 0, h, t1, t2;  // Time
        var minVelocity = 5; // Minimum px distance object must be dragged to enable momentum.
        var minDrag = 150;
        var maxH = $(window).height();
        var dragTransformInterval = false;

        //disable on iphone
        $mp.on('touchstart', (e) => {
            var Y = (e.touches[0].clientY || e.touches[0].pageY) - $mp.position().top + $mp.scrollTop();

            if (Y > 0 && Y < 250 ){
                y1 = 0; y2 = 0;
                y0 = e.touches[0].clientY || e.touches[0].pageY;
            }else{
                y0 = 0;
            }
        }).on('touchmove', (e) => {
            if (!y0) return;

            y1 = y2;
            y2 = e.touches[0].clientY ||  e.touches[0].pageY;

            $mp.css('top', Math.max(0, y2 - y0));
        }).on('touchend', (e) => {
            if (!y0) return;
            if ( y2 - y0 > minDrag || (y2 - y1 < -minVelocity)){
                this.close();
            }else{
                $mp.animate({top: 0}, 100);
            }
        })
    },

    methods: {
        submitForm(){
            if (this.loading) return;

            // close KEYBOARD
            this.loading = true;
            this.$refs.fieldName.blur();

            if (!this.fieldName.length){
                this.loading = false;
                return;
            }else{
                var requestData = {
                    name: this.fieldName
                }
                this.fieldName = "";

                this.$http.post(this.getPlaylistsEndpoint, requestData).then((success) => {
                    // fetch , refresh new list
                    this.$http.get(this.getPlaylistsEndpoint).then((success) => {
                        App.playlists = success.data.data;
                        this.playlistArray = App.playlists.sort(function(a,b){return b.songs_count - a.songs_count;});
                        this.scrollBottom();
                        this.loading = false;
                    });
                });
            }
        },

        scrollBottom(elem = "#playlist-popup .content ul.list"){
            $(elem).animate({ scrollTop: $(elem).prop("scrollHeight")}, 400);
        },  

        close() {
            this.$root.$emit('hidePlaylistManager');
        },
    },

    computed: {
        songPicture() {
            return this.song.id ? {'background-image': 'url('+ App.restApi + '/api/image/' + (this.song.picture_path || this.song.thumb) +')'} : {};
        },

        getPlaylistsEndpoint() {
            return App.restApi + '/api/v2/playlists';
        },

        getSongPlaylistsEndpoint() {
            return App.restApi + `/api/v2/songs/${this.song.id}/playlists`;
        }
    },

    beforeDestroy(){
        this.$root.$emit('unlockScroll');
    }
}
</script>
